import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3ParallelSettings } from 'ngx-modbus';

export const PARALLEL_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'parallel-settings',
  name: 'Parallel Settings',
  sections: [{
    id: 'parallel',
    labelKey: 'parallelSettings',
    registerTable: 'V3ParallelSettings',
    fields: [
      fieldRef(V3ParallelSettings, 'Parallel_Control'),
      fieldRef(V3ParallelSettings, 'Parallel_Master_Slave', {
        visibleWhen: { field: 'Parallel_Control', value: 0, operator: 'neq' },
      }),
      fieldRef(V3ParallelSettings, 'Parallel_Address', {
        visibleWhen: { field: 'Parallel_Control', value: 0, operator: 'neq' },
      }),
    ],
  }],
};
